import { Spin } from 'antd';
import { Component } from 'react';
import { connect } from 'react-redux';

import { TComma } from '../../../base/utils';
import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
// icons
import { ReactComponent as BottomArrow } from './../../../assets/svg/bottom-arrow.svg';
import { ReactComponent as EmptyBoxIcon } from './../../../assets/svg/empty-box.svg';
import styles from './Profile.module.css';

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: []
    };
    this.check_user();
  }

  check_user() {
    const { Login, history } = this.props;
    if (!Login.is_login) {
      history.push('/login/d/');
    }
  }

  componentDidMount() {
    this._GET_ORDERS();
  }

  _GET_ORDERS() {
    API.get
      .userOrders()
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false, data: response.data });
        } else {
          this.setState({ loading: false });
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error('Error : ', error);
      });
  }

  render() {
    const { loading, data } = this.state;
    const { history } = this.props;

    return (
      <Page
        address="/profile/"
        back
        className="page-profile"
        headerFix
        logo
        mobileContainer
        showFooter
        title="سفارشات من">
        {loading ? (
          <div className="text-center mt-5" style={{ marginTop: '20px' }}>
            <Spin size={`large ${styles.LoadingIcon}`} />
          </div>
        ) : null}
        {!!data && data.length === 0 && !loading ? (
          <div className={styles.EmptyContainer}>
            <EmptyBoxIcon className={styles.EmptyBoxIcon} />
            <div className={styles.EmptyText}>سفارشی وجود ندارد</div>
          </div>
        ) : null}
        <div className="factors-holder factors-scroll page-factor-factors-container">
          {data?.map((x, i) => (
            <div key={i}>
              <div key={i} className="factors-item page-factor-factors-item">
                <div className="w-100">
                  <label> تاریخ </label>
                  <span className="w-130">
                    <span className="pa-l-5"> {x.time} </span>
                    <span> {x.date} </span>
                  </span>
                </div>
                <div className="w-100">
                  <label> مبلغ </label>
                  <span>
                    {x.payable_amount === '-' ? (
                      ''
                    ) : (
                      <>
                        <span className="orders-toman-price"> {TComma(x.payable_amount)} </span>
                        <span className="orders-toman-text">تومان</span>
                      </>
                    )}
                  </span>
                </div>
                <hr className="global-hr" />
                <div
                  className="w-100 order-summary-btn"
                  onClick={() => history.push(`/order/${x.id}/`)}>
                  <span>جزئیات سفارش</span>
                  <div className="order-summary-arrow-container">
                    <BottomArrow />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Page>
    );
  }
}

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart
});
export default connect(mstp)(Orders);
